// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"234":"ca1efe2b3273ad40","5273":"4813cada987a05f6"}[chunkId] + ".js";
};